// extracted by mini-css-extract-plugin
export var Webhot = "index-module--Webhot--qeeP5";
export var cargoCard = "index-module--cargoCard--AOUFk";
export var webhotCargo = "index-module--webhotCargo--RvdTc";
export var webhotFooter = "index-module--webhotFooter--w2YXr";
export var webhotProduct = "index-module--webhotProduct--7oj1u";